// extracted by mini-css-extract-plugin
var _1 = "_serialNumberSearch-module__title";
export { _1 as "title" }
